import React from 'react';
import { Card, Col, Row } from "react-bootstrap";
import corner4 from "assets/img/illustrations/corner-4.png";
import Background from "components/common/background";
import { useTranslation } from "react-i18next";

const ClientDashboard = () => {
    const { t } = useTranslation();

    return (
        <>
            <Row className="g-3 mb-3">
                <Col lg={12} xxl={12}>
                    <Card className="mb-3 h-100">
                        <Background
                            image={corner4}
                            className="bg-card"
                            style={{
                                borderTopRightRadius: "0.375rem",
                                borderBottomRightRadius: "0.375rem",
                            }}
                        />
                        <Card.Body className="position-relative pe-4 pb-2">
                            <Row className="align-items-center flex-nowrap">
                                <Col>
                                    <h5 className="mb-0">{t("dashboard")}</h5>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="g-3">
                <Col lg={12}>
                    <Card className="flex-grow-0 shadow-none rounded-3 mb-3 card-hover border">
                        <Card.Body className="p-3 d-flex align-items-center justify-content-center" style={{ minHeight: "200px" }}>
                            <p className="text-500 fw-medium font-size-13 mb-0">{t("NoDataFound")}</p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default ClientDashboard;